import React, { useState, FC } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'

interface Ticket {
  reference_number: string
  [key: string]: any // In case ticket has additional properties you haven't defined yet
}

interface CommentModalProps {
  show: boolean
  handleClose: () => void
  handleSubmit: (referenceNumber: string, comment: string) => void
  ticket: Ticket
}

const CommentModal: FC<CommentModalProps> = ({
  show,
  handleClose,
  handleSubmit,
  ticket,
}) => {
  const [comment, setComment] = useState<string>('')

  const onSubmit = () => {
    handleSubmit(ticket.reference_number, comment)
    setComment('')
    handleClose()
  }

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Comment to Ticket #{ticket?.reference_number}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="commentTextarea">
            <Form.Label>Your Comment</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={comment}
              onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
                setComment(e.target.value)
              }
              placeholder="Write your message here..."
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onSubmit} disabled={!comment.trim()}>
          Submit Comment
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default CommentModal
